import { ROLES_MAP } from '@shared/constants/roles-map';
import { UserTiers } from '../../../constants/userTiers';

export const isUserAdminTier = tier => {
  return tier == UserTiers.ADMIN;
};

export const isUserIndustryOnlyTier = tier => {
  return tier == UserTiers.IndustryOnly;
};

export const isUserFDATier = tier => {
  return tier == UserTiers.FDA;
};

export const isUserOrgTier = tier => {
  return tier == UserTiers.Org;
};

export const isUserOrgTierByRole = roleId => {
  return ROLES_MAP[UserTiers.Org].includes(roleId);
};

export const isUserOrgUnitTier = tier => {
  return tier == UserTiers.OrgUnit;
};

export const isIsacaAppraisalTier = tier => {
  return tier == UserTiers.NoTier;
};
